// extracted by css-extract-rspack-plugin
export default {"city":"city-ylN2gr"};